import { iotRequest } from './iot_http';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;
const PATH = '/api/iot/assegnazioni';

// Every route here already exists server-side (BSDEVPLAT-84 for the writes,
// BSDEVPLAT-93 for the list, BSDEVPLAT-94 for the assignable controls). The
// panel adds no client-side route of its own.
//
// `iotRequest` (which wraps wrapFetchWithDetailedErrors) is used everywhere on
// purpose: the server refusals of IotAssegnazioneCrudService (deleted Controllo,
// Controllo the manual does not link to the equipment, Controllo without measured
// quantity or without complete Limiti, second Assegnazione on the same probe)
// carry the readable message the form has to show. wrapFetch would throw them
// away.

/**
 * One call per screen, not one per Assegnazione (BSDEVPLAT-93).
 * Il filtro per reparto che la rotta espone non e' passato: il pannello mostra
 * tutte le Assegnazioni dell'esercizio e non ha un selettore di reparto. Il
 * parametro va aggiunto qui insieme al controllo che lo pilota, non prima.
 */
export const getAssegnazioniIot = (esercizioId) =>
  iotRequest(
    `${BASE_URL}${PATH}?esercizioId=${encodeURIComponent(esercizioId)}`,
    'GET',
  );

/**
 * Assignable Controlli of one equipment, with the reason each non-assignable one
 * is out. `sn` travels as typed or scanned: canonicalisation is server-side only
 * (ADR-0013), the client never normalises it.
 */
export const getControlliAssegnabili = (attrezzaturaId, sn = null) => {
  const query =
    `?attrezzaturaId=${encodeURIComponent(attrezzaturaId)}` +
    (sn ? `&sn=${encodeURIComponent(sn)}` : '');
  return iotRequest(`${BASE_URL}${PATH}/controlli-assegnabili${query}`, 'GET');
};

export const creaAssegnazioneIot = ({
  macAddress,
  attrezzaturaId,
  controlloId,
  modalita,
}) =>
  iotRequest(BASE_URL + PATH, 'POST', {
    macAddress,
    attrezzaturaId,
    controlloId,
    modalita,
  });

// Il corpo e' quello del contratto e nient'altro: `ModificaAssegnazioneIotRequest`
// e' `(controlloId, modalita)`. `attrezzaturaId` veniva spedito e il server lo
// ignorava in silenzio — Jackson non fallisce sui campi ignoti — quindi cambiare
// attrezzatura in «Riassegna» rispondeva 200 senza spostare niente.
//
// L'attrezzatura non e' un campo dimenticato dal contratto: spostare una sonda
// cambia il suo `sn` canonico, che e' l'identita' su cui il consumatore chiava la
// riga di stato (ADR-0013) e quella che il rimappaggio di ADR-0008 conserva. E'
// per progetto rimozione + creazione, che e' anche cio' che lascia traccia di
// entrambe. La PUT sposta il Controllo, mai il soggetto.
export const aggiornaAssegnazioneIot = (id, { controlloId, modalita }) =>
  iotRequest(`${BASE_URL}${PATH}/${id}`, 'PUT', {
    controlloId,
    modalita,
  });

// Suspending is not disassociating (ADR-0010): the two live on different
// resources on purpose, so a mistake on one cannot silently do the other.
export const sospendiAssegnazioneIot = (id) =>
  iotRequest(`${BASE_URL}${PATH}/${id}/sospensione`, 'PUT');

export const riattivaAssegnazioneIot = (id) =>
  iotRequest(`${BASE_URL}${PATH}/${id}/sospensione`, 'DELETE');

export const rimuoviAssegnazioneIot = (id) =>
  iotRequest(`${BASE_URL}${PATH}/${id}`, 'DELETE');
